(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pli-collection-spotlight"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pli-spotlight-carousel')) {
  customElements.define('pli-spotlight-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.track = this.querySelector('[data-carousel-track]');
      this.slides = Array.from(this.querySelectorAll('[data-carousel-slide]'));
      this.previous = this.querySelector('[data-carousel-previous]');
      this.next = this.querySelector('[data-carousel-next]');
      this.status = this.querySelector('[data-carousel-status]');
      if (!this.track || !this.slides.length) return;
      this.current = -1;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.track.addEventListener('scroll', schedule, { ...options, passive: true });
      this.previous.addEventListener('click', () => this.goTo(this.current - 1), options);
      this.next.addEventListener('click', () => this.goTo(this.current + 1), options);
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey) return;
        const rtl = getComputedStyle(this.track).direction === 'rtl';
        let index;
        if (event.key === 'ArrowRight') index = this.current + (rtl ? -1 : 1);
        if (event.key === 'ArrowLeft') index = this.current + (rtl ? 1 : -1);
        if (event.key === 'Home') index = 0;
        if (event.key === 'End') index = this.slides.length - 1;
        if (index === undefined) return;
        event.preventDefault();
        this.goTo(index);
      }, options);
      this.resize = new ResizeObserver(schedule);
      this.resize.observe(this.track);
      this.querySelector('[data-carousel-controls]').hidden = this.slides.length < 2;
      this.update();
    }
    update() {
      if (!this.isConnected) return;
      const rtl = getComputedStyle(this.track).direction === 'rtl';
      const edge = rtl ? 'right' : 'left';
      const start = this.track.getBoundingClientRect()[edge];
      let closest = 0;
      let distance = Infinity;
      this.slides.forEach((slide, index) => {
        const offset = Math.abs(slide.getBoundingClientRect()[edge] - start);
        if (offset < distance) { closest = index; distance = offset; }
      });
      if (closest === this.current) return;
      this.current = closest;
      this.previous.disabled = closest === 0;
      this.next.disabled = closest === this.slides.length - 1;
      this.status.textContent = this.dataset.countTemplate.replace('__current__', closest + 1).replace('__total__', this.slides.length);
      this.slides.forEach((slide, index) => {
        slide.inert = index !== closest;
        slide.setAttribute('aria-hidden', String(index !== closest));
      });
    }
    goTo(index) {
      const target = this.slides[Math.max(0, Math.min(index, this.slides.length - 1))];
      const edge = getComputedStyle(this.track).direction === 'rtl' ? 'right' : 'left';
      const delta = target.getBoundingClientRect()[edge] - this.track.getBoundingClientRect()[edge];
      this.track.scrollBy({ left: delta, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.resize?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pli-velvet-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pli-oil-carousel')) {
  customElements.define('pli-oil-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.listenerController) return;
      this.track = this.querySelector('[data-oil-track]');
      this.previousButton = this.querySelector('[data-oil-previous]');
      this.nextButton = this.querySelector('[data-oil-next]');
      this.position = this.querySelector('[data-oil-position]');
      if (!this.track || !this.previousButton || !this.nextButton) return;
      this.listenerController = new AbortController();
      const options = { signal: this.listenerController.signal };
      this.previousButton.addEventListener('click', () => this.move(-1), options);
      this.nextButton.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', (event) => {
        if (event.target !== this.track) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.track.scrollTo({ left: event.key === 'Home' ? 0 : this.track.scrollWidth, behavior: this.scrollBehavior() });
        }
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.track);
      this.querySelector('.v-oil-controls').hidden = false;
      this.update();
    }
    disconnectedCallback() {
      this.listenerController?.abort();
      this.listenerController = null;
      this.resizeObserver?.disconnect();
    }
    scrollBehavior() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    }
    move(direction) {
      const card = this.track.firstElementChild;
      if (!card) return;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      const step = card.getBoundingClientRect().width + gap;
      const visibleCards = Math.max(1, Math.floor((this.track.clientWidth + gap) / step));
      this.track.scrollBy({ left: direction * step * visibleCards, behavior: this.scrollBehavior() });
    }
    update() {
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.previousButton.disabled = this.track.scrollLeft <= 2;
      this.nextButton.disabled = this.track.scrollLeft >= maximum - 2;
      const card = this.track.firstElementChild;
      if (card && this.position) {
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const step = card.getBoundingClientRect().width + gap;
        const current = Math.min(this.track.children.length, Math.round(this.track.scrollLeft / step) + 1);
        const text = this.position.dataset.positionTemplate.replace('[current]', String(current));
        if (this.position.textContent !== text) this.position.textContent = text;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
